import 'jquery';

export default () => {

    const bubleMenu = $('.header .buble-menu');

    $(document).on('click', '.js-btn-menu', function() {
        bubleMenu.show();
    });

    $(document).on('click', '.js-close-menu', function() {
        bubleMenu.hide();
    });

    let withSubMenus = $('#menu-buble-menu > .menu-item-has-children');
    let withDoubleSubMenus = $('#menu-buble-menu > .menu-item-has-children .sub-menu .menu-item-has-children');

    for(let i = 0; i < withSubMenus.length; i++) {
        $(withSubMenus[i]).append($('<span>', {class: "plus js-plus", text: "+"}));
    }

    for(let i = 0; i < withDoubleSubMenus.length; i++) {
        $(withDoubleSubMenus[i]).append($('<span>', {class: "plus js-plus", text: "+"}));
    }

    $(document).on('click', '.buble-menu .menu-item-has-children > .js-plus', function() {
        const $this = $(this).closest('li'),
              $thisPlus = $(this),
              subMenu = $this.find(' > .sub-menu'),
              mainContainer = $('.buble-menu');

        if($this.hasClass('active')) {
            $this.removeClass('active');
            subMenu.slideUp();
            $thisPlus.text('+');
        } else {
            $this.addClass('active');
            $thisPlus.text('-');
            subMenu.slideDown();
            $this.siblings('li').removeClass('active');
            $this.siblings('li').find('.js-plus').text('+');
            $this.siblings('li').find(' > .sub-menu').slideUp();
            mainContainer.css('height', 'auto')
        }
    });

    $(document).mouseup(function(e) {
        if (!bubleMenu.is(e.target) && bubleMenu.has(e.target).length === 0) {
            bubleMenu.hide();
        }
    });

    $(document).on('click', '.translate-btn a', function(e) {
        e.preventDefault();
        $('.google-translate').slideToggle('600');
    });



    $(document).on('click', '.js-mobile-costum-menu', function() {
        const $this = $(this);

        $this.closest('.custom-menu').find('ul').slideToggle();
    });

};


// WEBPACK FOOTER //
// ./scripts/modules/menu.js